const Post_Cert_uischema = (caseNumber) => ({
  name: "Add Post-Certification Request Document(s)",
  pageInfo: {
    text: "Use this action to upload post-certification documents. Uploaded case documents will be added to the case documents and directed to an analyst for review.​",
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          machine_name: "caseNumber",
          widget: "text",
          label: "Case Number *",
          maxLength: 100,
          disabled: true,
          value: caseNumber || "",
        },
        {
          machine_name: "document_description",
          widget: "select",
          label: "Document Category",
          selection: [
            "Contract Impossibility Request",
            "Certification Extension Request",
            "Re-Determination Request",
          ],
          validate: ["required"],
          tooltip: `Enter the document type of the Ad Hoc Document.`,
        },
        {
          machine_name: "case_note",
          widget: "text_area",
          label: "Document Description",
          validate: [
            {
              minLengthWithNA: 5,
              message: "E.5 must contain at least 5 characters",
            },
          ],
          inputLimit: 4000,
          rows: 8,
        },
        {
          machine_name: "files",
          widget: "file_upload",
          file_upload: { fileType: "Ad_Hoc_Document_Upload" },
          accept_multiple: false,
          required: true,
          validate: ["required", "file_required"],
          checkFilesAdded: true,
          documentAuth: "dh",
        },
      ],
    },
  ],
});

export default Post_Cert_uischema;
